import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return "Si è verificato un errore. Riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const previewUrl = (site) =>
  site.image_url ||
  (site.url ? `https://s.wordpress.com/mshots/v1/${encodeURIComponent(site.url)}?w=800&h=450` : "");
